import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0f92a352 = () => interopDefault(import('../pages/admin.vue' /* webpackChunkName: "pages/admin" */))
const _3b32d874 = () => interopDefault(import('../pages/brands.vue' /* webpackChunkName: "pages/brands" */))
const _3fe7175a = () => interopDefault(import('../pages/conversa/index.vue' /* webpackChunkName: "pages/conversa/index" */))
const _570219c8 = () => interopDefault(import('../pages/dashboard.vue' /* webpackChunkName: "pages/dashboard" */))
const _7360b636 = () => interopDefault(import('../pages/devices.vue' /* webpackChunkName: "pages/devices" */))
const _5a98369e = () => interopDefault(import('../pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _bb78f0e8 = () => interopDefault(import('../pages/messaging.vue' /* webpackChunkName: "pages/messaging" */))
const _139408c7 = () => interopDefault(import('../pages/reports.vue' /* webpackChunkName: "pages/reports" */))
const _27fc274b = () => interopDefault(import('../pages/settings.vue' /* webpackChunkName: "pages/settings" */))
const _11f800cc = () => interopDefault(import('../pages/status.vue' /* webpackChunkName: "pages/status" */))
const _4c82c3ae = () => interopDefault(import('../pages/upload.vue' /* webpackChunkName: "pages/upload" */))
const _8f2a0d46 = () => interopDefault(import('../pages/conversa/customers.vue' /* webpackChunkName: "pages/conversa/customers" */))
const _d6182008 = () => interopDefault(import('../pages/conversa/knox-customers.vue' /* webpackChunkName: "pages/conversa/knox-customers" */))
const _2163d680 = () => interopDefault(import('../pages/conversa/preferences.vue' /* webpackChunkName: "pages/conversa/preferences" */))
const _1279066a = () => interopDefault(import('../pages/conversa/register.vue' /* webpackChunkName: "pages/conversa/register" */))
const _1599e757 = () => interopDefault(import('../pages/conversa/edit-brand/_id.vue' /* webpackChunkName: "pages/conversa/edit-brand/_id" */))
const _72714b4c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/admin",
    component: _0f92a352,
    name: "admin"
  }, {
    path: "/brands",
    component: _3b32d874,
    name: "brands"
  }, {
    path: "/conversa",
    component: _3fe7175a,
    name: "conversa"
  }, {
    path: "/dashboard",
    component: _570219c8,
    name: "dashboard"
  }, {
    path: "/devices",
    component: _7360b636,
    name: "devices"
  }, {
    path: "/faq",
    component: _5a98369e,
    name: "faq"
  }, {
    path: "/messaging",
    component: _bb78f0e8,
    name: "messaging"
  }, {
    path: "/reports",
    component: _139408c7,
    name: "reports"
  }, {
    path: "/settings",
    component: _27fc274b,
    name: "settings"
  }, {
    path: "/status",
    component: _11f800cc,
    name: "status"
  }, {
    path: "/upload",
    component: _4c82c3ae,
    name: "upload"
  }, {
    path: "/conversa/customers",
    component: _8f2a0d46,
    name: "conversa-customers"
  }, {
    path: "/conversa/knox-customers",
    component: _d6182008,
    name: "conversa-knox-customers"
  }, {
    path: "/conversa/preferences",
    component: _2163d680,
    name: "conversa-preferences"
  }, {
    path: "/conversa/register",
    component: _1279066a,
    name: "conversa-register"
  }, {
    path: "/conversa/edit-brand/:id?",
    component: _1599e757,
    name: "conversa-edit-brand-id"
  }, {
    path: "/",
    component: _72714b4c,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
